import { createVNode as a, mergeProps as n } from "vue";
import c from "../node_modules/@pf-ui/pf-icon-svg/es/asn/SearchNoDataTwoTone.js";
import m from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return a(m, n(t, {
    icon: c
  }), null);
};
o.displayName = "SearchNoDataTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
